import React from "react";

const IMGS = [
  "https://images.unsplash.com/photo-1519068554083-0fb38e848f59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGZhY2FkZSUyMHBhaW50aW5nfGVufDB8fHx8MTc3Nzg5NjU4NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1704307023984-813727deade9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxzY2FuZGluYXZpYW4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc3Nzg5NjU4NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=1200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=1200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1200&q=80&auto=format&fit=crop",
];

export default function Gallery({ t }) {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-white border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <div
              className="text-[12px] tracking-[0.28em] uppercase text-[#475569] mb-4"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              — {t.gallery.eyebrow}
            </div>
            <h2
              className="text-[36px] sm:text-[44px] leading-[1.05] tracking-tight text-[#0A0F1C] font-medium"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              {t.gallery.title}
            </h2>
          </div>
          <p
            className="text-[15px] leading-relaxed text-[#475569] max-w-md"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            {t.gallery.desc}
          </p>
        </div>

        <div className="grid grid-cols-12 gap-3 md:gap-4">
          {/* Bento layout */}
          <div className="col-span-12 md:col-span-8 row-span-2 h-[300px] md:h-[520px] overflow-hidden group">
            <img
              src={IMGS[0]}
              alt="reference 1"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              data-testid="gallery-img-0"
            />
          </div>
          <div className="col-span-6 md:col-span-4 h-[200px] md:h-[252px] overflow-hidden group">
            <img
              src={IMGS[1]}
              alt="reference 2"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              data-testid="gallery-img-1"
            />
          </div>
          <div className="col-span-6 md:col-span-4 h-[200px] md:h-[252px] overflow-hidden group">
            <img
              src={IMGS[2]}
              alt="reference 3"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              data-testid="gallery-img-2"
            />
          </div>
          <div className="col-span-6 md:col-span-4 h-[200px] md:h-[260px] overflow-hidden group">
            <img
              src={IMGS[3]}
              alt="reference 4"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              data-testid="gallery-img-3"
            />
          </div>
          <div className="col-span-6 md:col-span-4 h-[200px] md:h-[260px] overflow-hidden group">
            <img
              src={IMGS[4]}
              alt="reference 5"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              data-testid="gallery-img-4"
            />
          </div>
          <div className="col-span-12 md:col-span-4 h-[200px] md:h-[260px] overflow-hidden group">
            <img
              src={IMGS[5]}
              alt="reference 6"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              data-testid="gallery-img-5"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
